import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast } from 'react-toastify';

const BASE_URL = 'http://192.168.0.57:5000';

export default function ManageTestimonial() {

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [total, setTotal] = useState(0);

  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    testimonial_name: '',
    testimonial_email: '',
    testimonial_address: '',
    testimonial_description: '',
    rating_id: '',
    image: null
  });
  const [viewData, setViewData] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);


  const handleView = async (id) => {
    try {
      const res = await API.get(`/testimonials/${id}`);
      setViewData(res.data);
      setViewOpen(true);
    } catch (e) {
      console.error(e);
      alert("Failed to load details");
    }
  };


  // FETCH
  const fetchData = () => {
    API.get(`/testimonials?page=${page}&limit=${limit}`)
      .then(res => {
        setData(res.data.data || []);
        setTotal(res.data.total || 0);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  // SUBMIT
  const handleSubmit = async () => {

    const fd = new FormData();
    fd.append("testimonial_name", form.testimonial_name);
    fd.append("testimonial_email", form.testimonial_email);
    fd.append("testimonial_address", form.testimonial_address);
    fd.append("testimonial_description", form.testimonial_description);
    fd.append("rating_id", form.rating_id);
    if (form.image) fd.append("image", form.image);

    try {
      if (editId) {
        await API.put(`/testimonials/${editId}`, fd);
        toast.success("Updated successfully");
      } else {
        await API.post('/testimonials', fd);
        toast.success("Added successfully");
      }

      // RESET
      setForm({
        testimonial_name: '',
        testimonial_email: '',
        testimonial_address: '',
        testimonial_description: '',
        rating_id: '',
        image: null
      });

      setEditId(null);
      fetchData();

    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  // EDIT CLICK
  const handleEdit = (row) => {
    setForm({
      testimonial_name: row.testimonial_name,
      testimonial_email: row.testimonial_email,
      testimonial_address: row.testimonial_address,
      testimonial_description: row.testimonial_description,
      rating_id: row.rating_id,
      image: null
    });
    setEditId(row.testimonial_id);
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    await API.delete(`/testimonials/${id}`);
    fetchData();
  };

  // STATUS
  const toggleStatus = async (row) => {
    await API.put(`/testimonials/status/${row.testimonial_id}`, {
      status: row.testimonial_sts ? 0 : 1
    });
    fetchData();
  };

  // HOMEPAGE
  const toggleHome = async (row) => {
    await API.put(`/testimonials/homepage/${row.testimonial_id}`, {
      show: row.testimonial_dispinfront ? 0 : 1
    });
    fetchData();
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <Layout activePage="Testimonial">

<div style={S.header}>
        <h2 style={S.title}>Manage Testimonials</h2>
        <p style={S.subtitle}>Add and manage Testimonials</p>
      </div>

      {/* FORM */}
      <div style={{... S.card}}>
        <h3>{editId ? "Edit Testimonial" : "Add Testimonial"}</h3>
        <div style={{display:'flex',justifyContent:'space-between'}}>
        <div style={S.fg}>
        <label style={S.label}>Name</label>
        <input style={{... S.input}}
          placeholder="Name"
          value={form.testimonial_name}
          onChange={e=>setForm({...form,testimonial_name:e.target.value})}
        />
        </div>
        <div style={S.fg}>
        <label style={S.label}>Email</label>
        <input style={{... S.input}}
          placeholder="Email"
          value={form.testimonial_email}
          onChange={e=>setForm({...form,testimonial_email:e.target.value})}
        />
        </div>
        <div style={S.fg}>
        <label style={S.label}>Address</label>
        <input style={{... S.input}}
          placeholder="Address"
          value={form.testimonial_address}
          onChange={e=>setForm({...form,testimonial_address:e.target.value})}
        />
        </div>
   </div>
        <textarea style={S.input}
          placeholder="Description"
          value={form.testimonial_description}
          onChange={e=>setForm({...form,testimonial_description:e.target.value})}
        />

        <select style={S.input}
          value={form.rating_id}
          onChange={e=>setForm({...form,rating_id:e.target.value})}
        >
          <option value="">Rating</option>
          {[1,2,3,4,5].map(r => <option key={r}>{r}</option>)}
        </select>

        <input style={S.input}
          type="file"
          onChange={e=>setForm({...form,image:e.target.files[0]})}
        />

        <button style={S.addBtn} onClick={handleSubmit}>
          {editId ? "Update" : "Save"}
        </button>
      </div>
      

      {/* TABLE */}
      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Name</th>
              <th style={S.th}>Email</th>
              <th style={S.th}>Rating</th>
              <th style={S.th}>Image</th>
              <th style={S.th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row,i)=>(
              <tr key={row.testimonial_id}>
                <td style={S.td}><span style={S.serial}>{(page-1)*limit+i+1}</span></td>
                <td style={S.td}><span style={S.serial}>{row.testimonial_name}</span></td>
                <td style={S.td}><span style={S.serial}>{row.testimonial_email}</span></td>
                <td style={S.td}><span style={S.serial}>{row.rating_id}</span></td>

                <td>
                  <img
                    src={`${BASE_URL}/testimonial/${row.testimonial_img}`}
                    width="60"
                  />
                </td>

                <td>
                  <button style={S.viewBtn} onClick={() => handleView(row.testimonial_id)}>
                  View
                  </button>
                  <button style={S.editBtn} onClick={()=>handleEdit(row)}>Edit</button>
                  <button style={S.delBtn} onClick={()=>handleDelete(row.testimonial_id)}>Delete</button>

                  <button style={S.viewBtn} onClick={()=>toggleStatus(row)}>
                    {row.testimonial_sts ? "Active" : "Inactive"}
                  </button>

                  <button style={S.editBtn} onClick={()=>toggleHome(row)}>
                    {row.testimonial_dispinfront ? "Home ON" : "Home OFF"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div>
          <button disabled={page===1} onClick={()=>setPage(page-1)}>Prev</button>
          <span>{page}/{totalPages}</span>
          <button disabled={page===totalPages} onClick={()=>setPage(page+1)}>Next</button>
        </div>
      </div>

      {viewOpen && (
  <div style={S.overlay} onClick={()=>setViewOpen(false)}>
    <div style={{ ...S.modalBox, maxWidth: 860 }} onClick={e=>e.stopPropagation()}>

      <div style={S.modalHead}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>View Testimonial</h3>
        <button style={S.closeBtn} onClick={()=>setViewOpen(false)}>✕</button>
      </div>

      {viewData ? (
        <div style={{ ...S.modalBody, fontFamily: 'Arial, sans-serif' }}>

          <div style={S.row}>
            <b>Name:</b>
            <span>{viewData.testimonial_name}</span>
          </div>

          <div style={S.row}>
            <b>Email:</b>
            <span>{viewData.testimonial_email}</span>
          </div>

          <div style={S.row}>
            <b>Address:</b>
            <span>{viewData.testimonial_address}</span>
          </div>

          <div style={S.row}>
            <b>Description:</b>
            <span>{viewData.testimonial_description}</span>
          </div>

          <div style={S.row}>
            <b>Rating:</b>
            <span>{viewData.rating_id} ⭐</span>
          </div>

          <div style={S.row}>
            <b>Image:</b>
            <img
              src={`${BASE_URL}/testimonial/${viewData.testimonial_img}`}
              style={{ width: 100, borderRadius: 8 }}
              alt=""
            />
          </div>

        </div>
      ) : (
        <div style={{ padding: 20 }}>Loading...</div>
      )}

      <div style={S.modalFooter}>
        <button style={S.cancelBtn} onClick={()=>setViewOpen(false)}>
          Close
        </button>
      </div>

    </div>
  </div>
)}

    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
    root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  
    /* Header */
  header: { marginBottom: 20 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },

    /* Main */
    main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },
    topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
    title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
    subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
    addBtn: { padding: '10px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 14, fontWeight: 700, fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(108,99,255,0.35)' },
  
    /* Filters */
    filterRow: { display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' },
    searchWrap: { display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
      border: '1px solid #e8e8e8', borderRadius: 10, padding: '8px 14px',
      flex: 1, minWidth: 220, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    searchInput: { border: 'none', outline: 'none', fontSize: 13, flex: 1,
      fontFamily: 'inherit', color: '#333', background: 'transparent' },
    clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
    filterSelect: { padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
      background: '#fff', minWidth: 180 },
  
    /* Card + Table */
    card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden',padding:'20px',marginBottom:'30px' },
    table: { width: '100%', borderCollapse: 'collapse' },
    theadRow: { background: '#fafafa' },
    th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
      textAlign: 'center', borderBottom: '2px solid #f0f0f0',
      textTransform: 'uppercase', letterSpacing: '0.5px' },
    tr: { transition: 'background 0.12s' },
    td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
    emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
    noImg: { width: 60, height: 40, background: '#f3f2ff', borderRadius: 6,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 },
  
    /* Chips */
    serial:     { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    nameChip:   { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    groupChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    stockChip:  { background: '#fff3f0', color: '#d45700', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    badge:      { borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },
    pctChip:   { borderRadius: 20, padding: '4px 12px', fontSize: 13, fontWeight: 700 },
    /* Action buttons */
    viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c',
      border: '1px solid #b8f0d0', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    editBtn: { marginRight: 5, background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    delBtn: { background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
      padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
      fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Pagination */
    pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
    paginInfo: { fontSize: 12, color: '#999' },
    pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
      fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  
    /* Modal */
    overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
    modalBox: { background: '#fff', borderRadius: 20, width: 740, maxWidth: '96vw', maxHeight: '90vh',
      display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
    modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '18px 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 },
    modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
    modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10,
      padding: '14px 22px', borderTop: '1px solid #f0f0f0', flexShrink: 0 },
    closeBtn: { background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
      borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
    cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666',
      border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
    submitBtn: { padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 13, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Form */
    section: { fontSize: 11, fontWeight: 800, color: '#6C63FF', textTransform: 'uppercase',
      letterSpacing: '0.8px', margin: '18px 0 10px', paddingBottom: 6,
      borderBottom: '1.5px solid #f3f2ff' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 14 },
    fg: { display: 'flex', flexDirection: 'column', gap: 5,width: '30%' },
    label: { fontSize: 12, fontWeight: 600, color: '#555' },
    req: { color: '#ff6b6b' },
    input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',marginBottom:'10px',
      boxSizing: 'border-box' },
  };
  